import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppMaterialModule } from './app.material.module';

import { SessionDataProvider } from '@providers/session-data/session-data';
import { environment } from '@environments/environment';
import { RedirectService } from '@providers/redirect/redirect.service';
import { SocketPrintProvider, SocketTicketProvider, SocketProvider, PasserPrintingAgentProvider } from '@providers/socket/socket';
import { SetDateStringProvider } from '@providers/setDateString/setDateString';
import { LoaderManagmentService } from '@providers/loader-managment/loader-managment.service';
import { SnackbarService } from '@providers/snackbar-services/snackbar.services';
import { AuthGuardService } from '@providers/authGuard/auth-guard.service';
import { AuthGuardRolesService } from '@providers/authGuard-roles/authGuard-roles.service';
import { RolesManagmentService } from '@providers/roles-managment/roles-managment.service';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { ModalService } from '@providers/modal-services/modal.service';
import { FormatPipe } from '@pipes/format';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CopnyManagmentService } from '@providers/copny-managment/copny-managment.service';
import { GOOGLE_MAPS_API_CONFIG, NgMapsGoogleModule } from '@ng-maps/google';
import { API_KEY_MAPS } from '@constants/generals';
import { NgMapsCoreModule } from '@ng-maps/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { FeatureFlagsService } from '@providers/feature-flags/feature-flags.service';
import { TranslationService } from '@providers/translation-new/translation.service';
import { ErrorInterceptor } from '@providers/error-interceptor/error-interceptor.service';
import { AuthInterceptor } from '@providers/auth-interceptor/auth-interceptor.provider';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';

// console.log = () => {};


const config: SocketIoConfig = {
  url: environment.socket_ticket_url,// socket_url,
  options: {
    reconnection: true,
    timeout: 10000,
    transports: ['polling']
  }
};

@NgModule({
  declarations: [AppComponent],
  entryComponents: [AppComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    AppMaterialModule,
    HttpClientModule,
    BrowserAnimationsModule,
    PickerModule,
    SocketIoModule.forRoot(config),
    NgMapsGoogleModule,
    NgMapsCoreModule,
  ],
  providers: [
    FeatureFlagsService, TranslationService,
    SessionDataProvider, RolesManagmentService,
    SocketPrintProvider, SocketTicketProvider, SocketProvider, PasserPrintingAgentProvider,
    SetDateStringProvider, RedirectService, AuthGuardService, AuthGuardRolesService,
    ModalService, FormatPipe, LoaderManagmentService, DatePipe,
    SnackbarService, CopnyManagmentService,
    {
      provide: GOOGLE_MAPS_API_CONFIG,
      useValue: {
        apiKey: API_KEY_MAPS,
        libraries: ['places']
      }
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CR' },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MatSnackBarRef, useValue: {} },
    { provide: MAT_SNACK_BAR_DATA, useValue: {} },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        logErrors: true,
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
